import axios from 'axios';
import LazyLoadImage from '../classes/lazyloadimage';

export default class SoonEventsSection {
    constructor() {
        try {
            axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
            if (!document.querySelector('#select-home-loc')) {
              return;
            }
            this.initElements();
            this.initEvents();
        } catch (e) {
            console.log(e);
            //do nothing, means that we're not one a page with location-select
        }
    }

    initElements() {
        this.endpoint = window.location.href.split('?')[0];
        const url = new URL(window.location.href);
        this.params = url.searchParams;

        this.location_select = document.getElementById('location-select');
        this.dataWrapper = document.getElementById('data-soon-events-wrapper');
        this.ikeLoader = document.getElementById('ike-loader');
        this.selectLoc = document.querySelector('#select-home-loc');
        this.selectLocOptions = this.selectLoc.querySelector('.custom-options');
        this.moreLink = document.querySelector('.soon-events-section .more-soon-events');

        this.lazyLoading = new LazyLoadImage();
    }

    initEvents() {
        // init cantons select (soon-events-end section)
        if(!!sessionStorage.getItem('cantonIndex')) {
            this.selectLocOptions.querySelector('.selected')?.classList.remove('selected');
            let selectedCanton = sessionStorage.getItem('cantonIndex');
            for(let option of this.selectLocOptions.querySelectorAll('.custom-option')) {
                option.classList.remove('selected');
                if(option.getAttribute('data-value') === selectedCanton) {
                    option.classList.add('selected');
                    this.selectLoc.querySelector('.custom-select__placeholder').parentNode.innerHTML =
                        `<span class="custom-select__placeholder">${option.innerHTML}</span> <span class="icon-chevron-down"></span>`;
                    break;
                }
            }
        } else {
            this.selectLoc.querySelector('.custom-select__placeholder').parentNode.innerHTML =
                `<span class="custom-select__placeholder">${this.selectLocOptions.querySelector('.selected').innerHTML}</span> <span class="icon-chevron-down"></span>`;
        }

        // load data
        this.setParams();
        this.updateData();

        const mapobserver = new MutationObserver(() => {
            sessionStorage.setItem('cantonIndex', this.selectLoc.querySelector('.selected')?.getAttribute('data-value'));
            this.setParams();
            this.updateData();
        });
        mapobserver.observe(this.selectLocOptions, { attributes: true, childList: true, subtree: true });
    }

    setParams() {
        const canton = this.selectLoc.querySelector('.selected');
        const cantonValue = canton?.getAttribute('data-value');
        this.params.set('canton', cantonValue);

        let moreUrl;
        if (cantonValue !== 'near') {
            moreUrl = new URL(window.location.href + '/' + canton?.getAttribute('data-slug'));
        } else {
            moreUrl = new URL(window.portal_conf.SEARCH_URI);
            moreUrl.searchParams.set('canton', cantonValue);
        }
        moreUrl.searchParams.set('sort', 'soon_as_possible');

        this.moreLink.href = moreUrl.href;
    }

    updateData() {
        this.ikeLoader.classList.remove('hidden');
        this.dataWrapper.classList.add('hidden');

        axios.get(`${this.endpoint}?${this.params}`)
            .then((response) => {
                // handle success

                this.ikeLoader.classList.add('hidden');
                this.dataWrapper.classList.remove('hidden');

                this.dataWrapper.innerHTML = response.data.html;
                this.lazyLoading.lazyLoading();

            })
            .catch((error) => {
                // handle error
                console.log(error);
            });
    }
}
